module.exports = __webpack_public_path__ + "static/img/ill2.4648ee9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/envi/ill2.png
// module id = 1PY2
// module chunks = 1